import RegistrationFormData from '../interfaces/RegistrationFormData';

export const transformFormData = (formData: RegistrationFormData) => ({
    ...formData,
    consent__insights__24: Boolean(formData.consent__insights__24)
});
